<template>
  <div>
    <div class="content">
      <div class="container">
        <div class="details">
          <div class="details_title">
          </div>
          <div class="details_content">
            <div v-html="content"></div>
          </div>
        </div>
        <div class="post_pages">
          <p>
            <span
              class="prev"
              :title="prevText"
              :class="{ special: change.noPrev }"
              @click="changeHander('prev')"
              >{{ prevText }}</span
            >
            <span
              class="next"
              :title="nextText"
              :class="{ special: change.noNext }"
              @click="changeHander('next')"
              >{{ nextText }}</span
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  data() {
    return {
      toHeaderB: {
        title: "",
        parent: "",
        parentLink: "/stepInWetland/stepInWetland",
        child: "",
        childLink: "",
        longTop: "",
        longBottom: "",
        shortValue: "",
        isLong: true,
        titleShow: false,
        searchShow: false,
        haveVoice: false,
        voiceImage: "",
        voiceTitle: "",
        voiceSrc: "",
        logoSrc: {
          backgroundImage: ""
        }
      },
      type: null,
      search: null,
      listData: null,
      prevText: "",
      nextText: "",
      content: "",
      detailsTitle: "",
      change: {
        nowIndex: null,
        nowId: "",
        noPrev: false,
        noNext: false
      }
    };
  },
  components: {},
  methods: {
    // 获取列表数据
    getListData() {
      if (this.type === 6) {
        this.axios
          .get(
            this.$store.state.Url10 + "wetland/impression/findAllIdAndName",
            {
              // 通过这种方式解决模糊匹配后台报空指针异常的问题
              params: {
                name: this.search || sessionStorage.search,
                soId: this.$store.state.Soid,
                type: 2
              }
            }
          )
          .then(data => {
            this.listData = data.data.data;
            this.showData();
          })
          .catch(err => {
            console.log(err);
          });
      } else if (this.type === 7) {
        this.axios
          .get(
            this.$store.state.Url10 + "wetland/impression/findAllIdAndName",
            {
              // 通过这种方式解决模糊匹配后台报空指针异常的问题
              params: {
                name: this.search || sessionStorage.search,
                soId: this.$store.state.Soid,
                type: 3
              }
            }
          )
          .then(data => {
            this.listData = data.data.data;
            this.showData();
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    // 获取详细数据
    getDetailsData() {
      this.toHeaderB.titleShow = false;
      if (this.type === 6) {
        this.axios
          .get(
            this.$store.state.Url10 +
              "wetland/protectmanage/queryRawsRegulationsById",
            {
              // 通过这种方式解决模糊匹配后台报空指针异常的问题
              params: {
                "wetlandLawsRegulations.id":
                  this.change.nowId || sessionStorage.id
              }
            }
          )
          .then(data => {
            data = data.data.data;
            this.content = data.content;
            this.setHeight();
          })
          .catch(err => {
            console.log(err);
          });
      } else if (this.type === 7) {
        this.axios
          .get(this.$store.state.Url10 + "notice/queryNoticeById", {
            // 通过这种方式解决模糊匹配后台报空指针异常的问题
            params: {
              ids: this.change.nowId || sessionStorage.id,
              soId: this.$store.state.Soid
            }
          })
          .then(data => {
            data = data.data.data;
            this.content = data.details;
            this.detailsTitle = data.title;
            this.setHeight();
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    // 自动判断内容高度，不足则补
    setHeight() {
      setTimeout(function() {
        $(".details").css("height", "auto");
        let contentHeight =
          $(window).height() -
          $(".logo").height() -
          $(".footer").height() -
          20 -
          $(".post_pages").height() -
          30 -
          60;
        if ($(".details").height() < contentHeight) {
          $(".details").height(contentHeight);
        }
      });
    },
    // 渲染数据
    showData() {
      window.scrollTo(0, 0);
      this.toHeaderB.titleShow = false;
      for (let i in this.listData) {
        if (
          this.change.nowId == this.listData[i].id ||
          sessionStorage.id === this.listData[i].id
        ) {
          this.change.nowIndex = i - 0;
          this.getDetailsData();
          if (this.change.nowIndex === 0 && this.listData.length > 1) {
            this.change.noPrev = true;
            this.prevText = "上一条: 无";
            this.change.noNext = false;
            this.nextText =
              "下一条: " + this.listData[this.change.nowIndex + 1].name;
          } else if (this.change.nowIndex === 0) {
            this.change.noPrev = true;
            this.prevText = "上一条: 无";
            this.change.noNext = true;
            this.nextText = "下一条: 无";
          } else if (this.change.nowIndex === this.listData.length - 1) {
            this.change.noPrev = false;
            this.prevText =
              "上一条: " + this.listData[this.change.nowIndex - 1].name;
            this.change.noNext = true;
            this.nextText = "下一条: 无";
          } else {
            this.change.noPrev = false;
            this.prevText =
              "上一条: " + this.listData[this.change.nowIndex - 1].name;
            this.change.noNext = false;
            this.nextText =
              "下一条: " + this.listData[this.change.nowIndex + 1].name;
          }
          break;
        }
      }
      this.toHeaderB.titleShow = true;
    },
    // 切换数据
    changeHander(type) {
      if (type === "prev") {
        if (this.change.nowIndex !== 0) {
          this.change.nowIndex--;
        } else {
          return;
        }
      } else if (type === "next") {
        if (this.change.nowIndex !== this.listData.length - 1) {
          this.change.nowIndex++;
        } else {
          return;
        }
      }
      window.scrollTo(0, 0);
      this.toHeaderB.titleShow = false;
      this.change.nowId = this.listData[this.change.nowIndex].id;
      sessionStorage.id = this.change.nowId;
      this.getDetailsData();
      if (this.listData[this.change.nowIndex - 1]) {
        this.change.noPrev = false;
        this.prevText =
          "上一条: " + this.listData[this.change.nowIndex - 1].name;
      } else {
        this.change.noPrev = true;
        this.prevText = "上一条: 无";
      }
      if (this.listData[this.change.nowIndex + 1]) {
        this.change.noNext = false;
        this.nextText =
          "下一条: " + this.listData[this.change.nowIndex + 1].name;
      } else {
        this.change.noNext = true;
        this.nextText = "下一条: 无";
      }
      this.toHeaderB.titleShow = true;
    }
  },
  mounted() {
    this.type = this.$route.query.type || sessionStorage.type - 0;
    this.change.nowId = this.$route.query.id
      ? (this.$route.query.id += "")
      : this.$route.query.id || sessionStorage.id;
    this.search = this.$route.query.search || sessionStorage.search;
    this.toHeaderB.title = "科普宣教";
    this.toHeaderB.parent = "科普宣教";
    if (this.type === 6) {
      this.toHeaderB.child = "政策法规";
      this.toHeaderB.longTop = "policies and";
      this.toHeaderB.longBottom = "regulations";
      this.toHeaderB.childLink = "/popularScience/popularScience/6";
      // this.toHeaderB.logoSrc.backgroundImage =
      //   "url(" + require("../../assets/images/banner/政策法规banner.png") + ")";
    } else if (this.type === 7) {
      this.toHeaderB.child = "通知通告";
      this.toHeaderB.longTop = "Inform";
      this.toHeaderB.longBottom = "Annunciate";
      this.toHeaderB.childLink = "/popularScience/popularScience/7";
      // this.toHeaderB.logoSrc.backgroundImage =
      //   "url(" + require("../../assets/images/banner/通知通告banner.png") + ")";
    }
    this.getListData();
    setTimeout(function() {
      $(".header_nav li")
        .eq(8)
        .find("span")
        .find("a")
        .attr("class", "header_native");
    }, 0);
  }
};
</script>

<style scoped="scoped">
.container {
  background: white;
}
.details {
  overflow: hidden;
  padding: 20px 7%;
  text-align: left;
}
.post_pages {
  padding: 0 7%;
  margin-top: 30px;
  height: 80px;
  box-sizing: border-box;
}
.post_pages p {
  line-height: 40px;
  overflow: hidden;
}
.post_pages span {
  display: inline-block;
  padding: 0 20px;
  width: 20%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: left;
  color: #15b559;
  border: 1px solid #15b559;
  transition: 0.2s linear;
  cursor: pointer;
}
.post_pages span:hover {
  background: #08961e;
  color: white;
}
.post_pages .special {
  cursor: not-allowed;
}
.post_pages .special:hover {
  background: transparent;
  color: #15b559;
}
.prev {
  float: left;
}
.next {
  float: right;
}

.details_title {
  text-align: center;
  padding: 20px 0;
}
</style>

<style>
.details_content img {
  display: block;
  margin: 0 auto;
  max-width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/popularScience/popularScience_post.vue